import { useEffect } from "react";
import { BiArea } from "react-icons/bi";
import { AiOutlineHome } from "react-icons/ai";
import { FaSwimmingPool, FaBath, FaBed } from "react-icons/fa";
import { GiHomeGarage } from "react-icons/gi";
import PopUp from "../../PopUp/PopUp";
import { sendAdToContacts } from "../../../api/mails.api";
import { GvreLogo } from "../../../icons/index";

export default function AdsMatchingPopUp({
  handlePopUp,
  adById,
  user,
  requestsToSend,
}) {
  useEffect(() => {
    adById.adDirectionSelected = undefined;
  }, [adById]);
  const maskTemplate = (value, ref) => {
    let render = "";
    if (value === null || value === undefined) return <p></p>;
    if (
      (ref === "sale" && value === 999999999) ||
      (ref === "rent" && value === 999999999)
    ) {
      render = <p>Valor máx.</p>;
    } else if (value === 0) {
      render = <p>Sin precio</p>;
    } else {
      if (ref === "sale" || ref === "rent")
        render = (
          <p>{`${Math.round(value)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${
            ref === "sale" ? " €" : " €/mes"
          }`}</p>
        );
      else
        render = (
          <p>
            {value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} m
            <sup>2</sup>
          </p>
        );
    }
    return render;
  };

  const maskValues = (value, ref) => {
    let render = "";
    if (value === null || value === undefined) return <p></p>;
    if (
      (ref === "sale" && value === 999999999) ||
      (ref === "rent" && value === 999999999) ||
      (ref === "buildSurface" && value === 999999999) ||
      (ref === "plotSurface" && value === 999999999)
    ) {
      render = <p>Valor máx.</p>;
    } else if (value === 0) {
      render = <p>Valor mín.</p>;
    } else {
      if (ref === "sale" || ref === "rent")
        render = (
          <p>{formatCurrency(value) + (ref === "sale" ? " €" : " €/mes")}</p>
        );
      else {
        render = (
          <p>
            {value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} m
            <sup>2</sup>
          </p>
        );
      }
    }
    return render;
  };

  const formatCurrency = (value) => {
    return Math.round(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <PopUp
      handlePopUp={handlePopUp}
      height="95%"
      mobileHeight="85%"
      width="60%"
      title="Plantilla de email"
      buttons={
        <>
          <button className="buttonFormCancel" onClick={handlePopUp}>
            Cancelar
          </button>
          <button
            className="buttonForm"
            onClick={() => {
              sendAdToContacts({
                consultant: user,
                subject: document.getElementById("subject").value,
                messageP1: document.getElementById("mailMessage1").value,
                messageP2: document.getElementById("mailMessage2").value,
                messageP3: document.getElementById("mailMessage3").value,
                messageGoodbyeP1: document.getElementById("mailMessage4").value,
                messageGoodbyeP2: document.getElementById("mailMessage5").value,
                requestsToSend,
                ad: adById,
              });
              alert(`Mensajes enviados`);
              handlePopUp();
            }}
          >
            Enviar
          </button>
        </>
      }
      fixedButtons={true}
    >
      {/* // ================================================================================ */}
      <div className="EmailTemplate">
        <div className="EmailTemplate__Header">
          <GvreLogo
            style={{
              width: "6%",
              color: "#FFF",
              bottom: "50%",
              left: "50%",
              margin: 12,
            }}
          />
        </div>
        <div className="EmailTemplate__Body">
          {/* INTRO */}
          <div className="EmailTemplate__Body__Introduction">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h5 style={{ marginRight: 12 }}>Asunto:</h5>
              <textarea
                id="subject"
                defaultValue={`Estimado/a, desde GV Real Estate te recomendamos el siguiente inmueble`}
                onChange={(ev) => {
                  console.log(ev.target.value);
                }}
              />
            </div>
            <textarea
              id="mailMessage1"
              // defaultValue={`Buenos días ${requestsToSend[0].requestContact.fullName}`}
              defaultValue={`Buenos días `}
              onChange={(ev) => {
                console.log(ev.target.value);
              }}
            />
            <textarea
              id="mailMessage2"
              defaultValue={`Tal y como hemos hablado, te envío información sobre los diferentes inmuebles.`}
              onChange={(ev) => console.log(ev.target.value)}
            />
            <textarea
              id="mailMessage3"
              defaultValue={`En cada enlace podrás encontrar información al respecto, además te indico dirección exacta. Si tienes dudas no dudes en contactar conmigo`}
              onChange={(ev) => console.log(ev.target.value)}
            />
          </div>
          {/* ESTATES */}
          <div className="EmailTemplate__Body__Estates">
            <div className="EmailTemplate__Body__Estates__Item">
              <div className="EmailTemplate__Body__Introduction">
                <textarea
                  placeholder={"Inserte un comentario"}
                  defaultValue={""}
                  onChange={(ev) => (adById.adComment = ev.target.value)}
                  style={{ minHeight: "5%" }}
                />
              </div>
              <div className="EmailTemplate__Body__Introduction--Options">
                <p>Envío de dirección</p>
                <div>
                  <input
                    type="radio"
                    id={`No enviar dirección`}
                    name={`Direction`}
                    defaultChecked
                    onChange={() => {
                      adById.adDirectionSelected = undefined;
                    }}
                  />
                  <label htmlFor={`No enviar dirección`}>
                    No enviar dirección
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    verticalAlign: "middle",
                  }}
                >
                  <input
                    type="radio"
                    id={`Incluir dirección con número incluido`}
                    name={`Direction`}
                    onChange={(ev) => {
                      if (ev.target.checked) {
                        adById.adDirectionSelected =
                          adById.adDirection.address.street +
                          " " +
                          adById.adDirection.address.directionNumber +
                          ", " +
                          adById.adDirection.city;
                      } else {
                        adById.adDirectionSelected = undefined;
                      }
                    }}
                  />
                  <label htmlFor={`Incluir dirección con número incluido`}>
                    Incluir dirección con número incluido
                  </label>
                </div>
                <div>
                  <input
                    type="radio"
                    id={`Incluir dirección sin número`}
                    name={`Direction`}
                    onChange={(ev) => {
                      if (ev.target.checked) {
                        adById.adDirectionSelected =
                          adById.adDirection.address.street +
                          ", " +
                          adById.adDirection.city;
                      } else {
                        adById.adDirectionSelected = undefined;
                      }
                    }}
                  />
                  <label htmlFor={`Incluir dirección sin número`}>
                    Incluir dirección sin número
                  </label>
                </div>
              </div>
              <h5>
                <b>
                  {adById.adDirection.address.street +
                    " " +
                    adById.adDirection.address.directionNumber +
                    ", " +
                    adById.adDirection.city}
                </b>
              </h5>
              <div className="EmailTemplate__Body__Title">
                <textarea
                  style={{
                    display: "block",
                    fontSize: "1.17em",
                    marginTop: "1em",
                    marginBottom: "1em",
                    marginLeft: "0",
                    marginRight: "0",
                    fontWeight: "bold",
                    minWidth: "5%",
                  }}
                  defaultValue={adById.title}
                  onChange={(ev) => {
                    adById.titleEdited = ev.target.value;
                  }}
                />
              </div>
              {adById.images.main ? (
                <img
                  src={adById.images.main}
                  alt="Imagen principal"
                  style={{
                    width: "76%",
                    marginBottom: 20,
                  }}
                />
              ) : (
                <img
                  src="\defaultImage.png"
                  alt="Imagen por defecto"
                  style={{
                    width: "75%",
                    height: "100%",
                    borderRadius: "4px",
                    marginRight: 12,
                    marginLeft: "10%",
                    marginBottom: 20,
                  }}
                />
              )}

              <h4>
                {adById.adType.includes("Venta")
                  ? maskTemplate(adById.sale.saleValue, "sale")
                  : maskTemplate(adById.rent.rentValue, "rent")}
              </h4>

              <p>REF {adById.adReference}</p>

              <div className="EmailTemplate__Body__Estates__Item__Properties">
                {adById.plotSurface !== 0 &&
                  adById.plotSurface !== 999999999 &&
                  adById.plotSurface !== null && (
                    <div>
                      <BiArea
                        style={{
                          transform: "scale(150%)",
                        }}
                      />
                      <p>{maskValues(adById?.plotSurface, "plotSurface")}</p>
                    </div>
                  )}
                {adById.buildSurface !== 0 &&
                  adById.buildSurface !== 999999999 &&
                  adById.buildSurface !== null && (
                    <div>
                      <AiOutlineHome
                        style={{
                          transform: "scale(150%)",
                        }}
                      />
                      <p>{maskValues(adById?.buildSurface, "buildSurface")}</p>
                    </div>
                  )}
                {adById.quality.parking !== 0 && (
                  <div>
                    <GiHomeGarage
                      style={{
                        transform: "scale(150%)",
                      }}
                    />
                    <p>{adById.quality.parking}</p>
                  </div>
                )}
                {adById.quality.outdoorPool !== 0 && (
                  <div>
                    <FaSwimmingPool
                      style={{
                        transform: "scale(150%)",
                      }}
                    />
                    <p>{adById.quality.outdoorPool}</p>
                  </div>
                )}
                {adById.quality.bathrooms !== 0 && (
                  <div>
                    <FaBath
                      style={{
                        transform: "scale(150%)",
                      }}
                    />
                    <p>{adById.quality.bathrooms}</p>
                  </div>
                )}
                {adById.quality.bedrooms !== 0 && (
                  <div>
                    <FaBed
                      style={{
                        transform: "scale(150%)",
                      }}
                    />
                    <p>{adById.quality.bedrooms}</p>
                  </div>
                )}
              </div>

              <p>{adById.description.emailPDF}</p>

              <div className="EmailTemplate__Body__Estates__Item__Button">
                <button
                // onClick={() => history.push(`/anuncios/${ad._id}`)}
                >
                  Saber más
                </button>
              </div>
            </div>
          </div>
          {/* CONCLUSION  */}
          <div className="EmailTemplate__Body__Introduction">
            <textarea
              id="mailMessage4"
              defaultValue={`Si quieres organizar alguna visita por favor ponte en contacto conmigo.`}
              onChange={(ev) => console.log(ev.target.value)}
            />
            <textarea
              id="mailMessage5"
              defaultValue={`Un cordial saludo,`}
              onChange={(ev) => console.log(ev.target.value)}
            />
          </div>
          {/* SIGNATURE */}
          <div className="EmailTemplate__Body__Signature">
            <GvreLogo
              style={{
                width: "8%",
                color: "#2B363D",
                bottom: "-52%",
                left: "-78%",
              }}
            />
            <div>
              <p>{user.fullName}</p>
              <p>
                {user.profession
                  ? `${user.position} | ${user.profession}`
                  : `${user.position}`}
              </p>
              <p>
                {user.consultantPhoneNumber
                  ? `${user.consultantMobileNumber} | ${user.consultantPhoneNumber}`
                  : `${user.consultantMobileNumber}`}
              </p>
              {user.offices?.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {user.offices.map((office, index) => {
                    return <span key={index}>{office}</span>;
                  })}
                </div>
              ) : (
                <>
                  {user.office2
                    ? `${user.office1} | ${user.office2}`
                    : `${user.office1}`}
                </>
              )}
              <p>{user.consultantEmail}</p>
            </div>
          </div>
        </div>
      </div>
    </PopUp>
  );
}
